import React from 'react';
import { TextField } from '@material-ui/core';

export default function DateTime({
  value = null,
  onChange = () => null,
  required = false,
  helperText = '',
  error,
  isRestriction = false,
  type = 'datetime-local',
  disabled = false,
}) {
  return (
    <TextField
      error={error}
      required={required}
      helperText={helperText}
      value={value}
      type={type}
      onChange={onChange}
      variant="outlined"
      style={{ marginTop: '5px', display: 'flex' }}
      inputProps={{
        min: !isRestriction ? new Date().toISOString().slice(0, 16) : '',
        'data-testid': 'date-time-picker',
      }}
      placeholder="dd/mm/yyyy, --:-- --"
      disabled={disabled}
    />
  );
}
